import axios from "axios";

const postDoctorPrivateNote = async (baseUrl, token, doctorId, appointmentId, doctorNote) => {

    const config = {
        headers: { Authorization: `Bearer ${token}`,
                   "Content-Type": "multipart/form-data" 
                 }
    };

    var bodyFormData = new FormData();
    bodyFormData.append('doctornote', doctorNote);

    let putResponse = null

    await axios.post(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointmentId + "/note/doctor", bodyFormData, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return putResponse
}

export default postDoctorPrivateNote;